(() => {
  if (customElements.get('te-product-service')) return;
  customElements.define('te-product-service', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      this.message = this.querySelector('[data-delivery-message]');
      if (!this.root || !this.message) return;
      try { this.messages = JSON.parse(this.querySelector('[data-delivery-messages]').textContent); }
      catch (_) { return; }
      this.onChange = (event) => {
        if (event.target.closest('variant-selects')) this.message.textContent = 'Vérification du délai pour cette taille…';
      };
      this.onVariant = (event) => this.update(event.detail?.variant);
      this.root.addEventListener('change', this.onChange, true);
      this.root.addEventListener('theme:variant:prices-updated', this.onVariant);
      if (window.subscribe && window.theme?.PUB_SUB_EVENTS?.variantChange) {
        this.unsubscribe = window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data?.sectionId === this.root.dataset.section || data?.sectionId === this.root.dataset.originalSection) this.update(data.variant);
        });
      }
    }
    update(variant) {
      this.message.textContent = variant
        ? (this.messages[String(variant.id)] || 'Délai d’expédition à confirmer pour cette taille.')
        : 'Cette combinaison est actuellement indisponible.';
    }
    disconnectedCallback() {
      this.root?.removeEventListener('change', this.onChange, true);
      this.root?.removeEventListener('theme:variant:prices-updated', this.onVariant);
      this.unsubscribe?.();
    }
  });
})();
